import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const TimelineKeyframeShiftContent = () => {
	const {fps, width, height} = useVideoConfig();
	// The imported cursor keyframes use the original 30 fps capture clock.
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<CloseUpFrame>
			<AbsoluteFill
				name="Canvas Capture"
				durationInFrames={(182 / 30) * fps}
				style={{
					width: 2560,
					height: 1260,
					left: '50%',
					top: '50%',
					translate: '-1560px -640px',
					transformOrigin: '1560px 640px',
					scale: Math.min(width / 2560, height / 1600) * 1.6,
				}}
			>
				<Video
					src="https://remotion.media/studio-close-ups/timeline-keyframe-marquee-shift-be06b0bb212a.mp4"
					durationInFrames={(182 / 30) * fps}
					muted
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						frame,
						[2, 51, 126],
						['auto', 'default', 'auto'],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							frame,
							[0, 20, 22, 33, 64, 75, 120, 149, 152],
							[
								4.4847124517559465, 4.036241206580352, 4.4847124517559465,
								4.036241206580352, 4.4847124517559465, 4.036241206580352,
								4.4847124517559465, 4.036241206580352, 4.4847124517559465,
							],
							{
								easing: Easing.step1,
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							frame,
							[
								2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 23,
								24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
								40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
								56, 57, 58, 59, 60, 65, 66, 77, 78, 80, 81, 82, 83, 84, 85, 86,
								87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101,
								102, 103, 104, 105, 125, 126, 130, 131, 132, 133, 134, 135, 136,
								137, 138, 139, 140, 141, 142, 143, 144, 145, 146,
							],
							[
								'3400.235403607697px 1303.7549612678947px',
								'3073.271836421865px 1230.598089398626px',
								'2586.084909533846px 1110.0013686256261px',
								'2189.8010018339583px 1019.2560151096269px',
								'2085.0058850901924px 997.0076369309938px',
								'2080.223359702187px 994.6426518490132px',
								'2070.956121862426px 990.0528289491692px',
								'2065.5429337858923px 981.9242876303615px',
								'2036.8477814578598px 962.3562258779733px',
								'1970.417978266225px 931.6114198122245px',
								'1886.1369173076396px 905.2987709741877px',
								'1768.8336572413982px 875.5174773492458px',
								'1733.621657131908px 867.774341006761px',
								'1727.7880272630223px 866.75827334191px',
								'1724.985081980675px 866.6881997098513px',
								'1723.6712013795745px 866.5130156297046px',
								'1723.5660909314865px 866.5130156297046px',
								'1723.5660909314865px 866.5130156297046px',
								'1731.712150658309px 864.4808803000027px',
								'1742.0830482029944px 861.0647907371417px',
								'1753.154682068267px 858.2092902307502px',
								'1771.5840472997015px 851.7274792653217px',
								'1788.4893110338596px 843.8617140667342px',
								'1791.782771740618px 842.5127966496044px',
								'1792.1156214928967px 842.0397996332083px',
								'1792.1156214928967px 842.0397996332083px',
								'1792.1156214928967px 841.5843210248269px',
								'1792.1156214928967px 840.936139928284px',
								'1792.1156214928967px 840.2704404237264px',
								'1775.8059836312375px 825.8703090356663px',
								'1775.8059836312375px 825.8703090356663px',
								'1739.227547696603px 800.9591328388033px',
								'1739.227547696603px 800.9591328388033px',
								'1696.4125585087454px 773.9457476801796px',
								'1654.5961185777242px 754.8331645361727px',
								'1654.5961185777242px 754.8331645361727px',
								'1592.545917389757px 736.1760600005474px',
								'1560.750006843128px 726.4533435524046px',
								'1560.750006843128px 726.4533435524046px',
								'1543.3367092765445px 718.5875783538171px',
								'1521.754030602469px 707.76120220075px',
								'1521.754030602469px 707.76120220075px',
								'1508.0020803109517px 703.1888977089206px',
								'1508.0020803109517px 703.1888977089206px',
								'1500.4691648646428px 698.0735225686366px',
								'1493.269099170613px 693.5012180768073px',
								'1493.269099170613px 693.5012180768073px',
								'1486.2266991487147px 689.2792817452714px',
								'1486.2266991487147px 689.2792817452714px',
								'1481.461692168724px 685.9157474064544px',
								'1481.461692168724px 685.9157474064544px',
								'1478.0456026058632px 682.2894369474174px',
								'1473.6660006021953px 677.9098349437495px',
								'1473.6660006021953px 677.9098349437495px',
								'1472.7900802014617px 677.454356335368px',
								'1472.7900802014617px 677.454356335368px',
								'1468.603180685955px 677.454356335368px',
								'1468.603180685955px 677.454356335368px',
								'1493.5318752908329px 679.0660498727178px',
								'1493.5318752908329px 679.0660498727178px',
								'1560.277009826732px 680.9054827142583px',
								'1560.277009826732px 680.9054827142583px',
								'1653.75523499302px 682.7799523718281px',
								'1653.75523499302px 682.7799523718281px',
								'1754.4160074453234px 682.7799523718281px',
								'1754.4160074453234px 682.7799523718281px',
								'1847.3511619631565px 683.9887225248406px',
								'1847.3511619631565px 683.9887225248406px',
								'1909.699176087373px 685.7405633263077px',
								'1909.699176087373px 685.7405633263077px',
								'1974.517285741658px 688.4033613445378px',
								'1974.517285741658px 688.4033613445378px',
								'1995.1014151588972px 690.0676101059316px',
								'1995.1014151588972px 690.0676101059316px',
								'2008.3278132099745px 691.434045931076px',
								'2008.3278132099745px 691.434045931076px',
								'2020.730846084362px 691.9595981715162px',
								'2020.730846084362px 691.9595981715162px',
								'2032.6433635343387px 692.7128897161471px',
								'2032.6433635343387px 692.7128897161471px',
								'2039.0551008677085px 692.9055922043084px',
								'2039.0551008677085px 692.9055922043084px',
								'2043.4171844633618px 693.3435524046752px',
								'2043.4171844633618px 693.3435524046752px',
								'2044.4507705362273px 693.3435524046752px',
								'2044.4507705362273px 693.3435524046752px',
								'2044.4507705362273px 693.991733501218px',
								'2044.4507705362273px 693.991733501218px',
								'2047.4464183067362px 694.5873593737169px',
								'2277.953630963786px 766.9383844743109px',
								'2638.955464922125px 880.0897818410751px',
								'2963.6591574740646px 992.733145375414px',
								'3179.8538307831273px 1087.332548654641px',
								'3274.8386390386772px 1135.9286124873402px',
								'3380.7899707114116px 1213.044644567925px',
								'3463.5469301727203px 1297.7987025429063px',
								'3506.4319929926364px 1336.0939424629787px',
								'3547.9331015793937px 1374.0563326307722px',
								'3571.5303971751564px 1396.2346371773465px',
								'3574.245750417431px 1398.4594749952098px',
								'3574.245750417431px 1400.9120521172638px',
								'3573.9654558891957px 1408.164673035338px',
								'3573.107053896477px 1411.0727287657733px',
								'3572.266170311773px 1412.6493854870937px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</CloseUpFrame>
	);
};

export const TimelineKeyframeShiftComposition = Interactive.create({
	Component: TimelineKeyframeShiftContent,
	layout: 'absolute-fill',
	schema: {},
});
